export default (form) => {
    if (!form || !form.elements) {
        return;
    }
    const inputElements = form.querySelectorAll('.hide-error-msg');
    inputElements.forEach((input) => {
        input.classList.remove('hide-error-msg');
    });
};
